import { render } from "./MenuPesquisa.vue?vue&type=template&id=567378f9"
import script from "./MenuPesquisa.vue?vue&type=script&lang=js"
export * from "./MenuPesquisa.vue?vue&type=script&lang=js"

import "./MenuPesquisa.vue?vue&type=style&index=0&id=567378f9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__